export default class PopularPlace {
    constructor(data = {}) {
        this.order = data.order || 0;
        this.name = data.name || undefined;
        this.averagePrice = data.averagePrice || 0;
        this.setImage(data.image);
        this.numberOfVacancies = data.numberOfVacancies || 0;
        this.id = data.id || undefined;
        this.isActive = data.isActive || true;
    }

    setImage(url, name){
        this.image = url && {url, name}
    }

    removeImage(url){
        this.image = undefined;
    }

    export(){
        return {
            id: this.id,
            name: this.name,
            order: this.order,
            image: this.image && this.image.url,
            averagePrice: this.averagePrice,
            numberOfVacancies: this.numberOfVacancies,
            isActive: this.isActive,
        }
    }
}
